namespace Matrix.Administration {
    export interface RunBookListResponse extends Serenity.ListResponse<string> {
    }
}
